import { Tabs } from "antd";
import { Wraper } from "./style";

export default ({ onChange, ...rest }) => {
  const items = [
    {
      key: "UZL",
      label: "UZL",
    },
    {
      key: "UZK",
      label: "UZK",
    },
    {
      key: "RUS",
      label: "RUS",
    },
    {
      key: "ENG",
      label: "ENG",
    },
  ];
  return (
    <Wraper>
      <Tabs defaultActiveKey="1" items={items} onChange={onChange} {...rest} />
    </Wraper>
  );
};
